export function splitStreamingPreviewText(text: string) {
  if (!text) {
    return { committedText: '', previewText: '' };
  }

  const lastNewlineIndex = text.lastIndexOf('\n');
  if (lastNewlineIndex < 0) {
    return { committedText: '', previewText: text };
  }

  return {
    committedText: text.slice(0, lastNewlineIndex + 1),
    previewText: text.slice(lastNewlineIndex + 1),
  };
}
